export default {
  client: {
    type: 'CLIENT',
    fields: ['name', 'messages', 'forms', 'careplan', 'messageLast', 'messageLastWeek', 'primaryRelationship', 'callTranscript'],
  },
  caregiver: {
    type: 'CAREGIVER',
    fields: ['name', 'messages', 'bio', 'messageLast', 'messageLastWeek'],
  },
  requester: {
    type: 'USER',
    fields: ['name', 'email'],
  },
};
